import { Modal as AntModal, theme as antdTheme } from 'antd';
import styled from 'styled-components';

const { screenSMMax } = antdTheme.getDesignToken();

export const Modal = styled(AntModal).attrs({
  width: { xs: '95%', md: '60%', xl: '40%' }
})``;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.primary};
  margin: 0;

  @media only screen and (max-width: ${screenSMMax}px) {
    font-size: 18px;
  }
`;

export const ModalContent = styled.p`
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme.textSecondary};
  margin: 20px 0;

  @media only screen and (max-width: ${screenSMMax}px) {
    font-size: 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  @media only screen and (max-width: ${screenSMMax}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
